const VMActions = {
  CHANGE_TITLE_AND_SCENE: 'changeTitleAndScene',
};

const VMScenes = {
  TODAY: 'ACT', // ACTUALIDAD
  SEARCH: 'BUS', // BUSCADOR
  CUSTOMER: 'CLI', // CLIENTE
  COMMERCIAL: 'COM', // COMERCIAL
  OFFICE: 'OFI', // Oficina
  PEOPLE: 'PER', // Personas
  PRODUCTS: 'PRO', // Productos
  HIGHLIGHTS: 'RAP', //ATENCIÓN rápida
  HOME: 'DES', // Desarrollo
};

interface VMTitleAndSceneInfo {
  tabTitle?: string;
  scene?: string;
}

export { VMActions, VMScenes, VMTitleAndSceneInfo };
